import { render, staticRenderFns } from "./PlayerAttachmentsMobile.vue?vue&type=template&id=56daa846&scoped=true&"
import script from "./PlayerAttachmentsMobile.vue?vue&type=script&lang=js&"
export * from "./PlayerAttachmentsMobile.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAttachmentsMobile.vue?vue&type=style&index=0&id=56daa846&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56daa846",
  null
  
)

export default component.exports